import PrivateDiscussionsPage from './PrivateDiscussionsPage';
export default () => {
  PrivateDiscussionsPage();
};
flarum.reg.add('fof-byobu', 'forum/pages', );